import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { SearchArea, PageArea, ContactArea } from './styled';
import Cookies from 'js-cookie';
import { isLogged } from '../../helpers/AuthHandler';
import useApi from '../../helpers/SalatoAPI'
import Reveal from '../../components/Reveal';
import SmoothImage from '../../components/SmoothImage';
import FloatingShapes from '../../components/FloatingShapes';
import { WHATSAPP_URL } from '../../components/WhatsAppButton';
import ClientsMap from '../../components/ClientsMap';

const mockProducts = [
	{
		id: 1,
		title: 'Coxinha de Frango com Catupiry',
		category: 'Linha Lanche',
		image: require('../../assets/images/coxinhacatupiry.webp'),
		link: '/produtos',
	},
	{
		id: 2,
		title: 'Bolinho de Queijo',
		category: 'Linha Mini',
		image: require('../../assets/images/bolinhadequeijo.webp'),
		link: '/produtos',
	},
	{
		id: 3,
		title: 'Bolinho de Aipim com Carne Seca',
		category: 'Linha Mini e Lanche',
		image: require('../../assets/images/aipimcarneseca.webp'),
		link: '/produtos',
	},
	{
		id: 4,
		title: 'Salsicha Empanada',
		category: 'Linha Mini e Lanche',
		image: require('../../assets/images/salsichaemp.webp'),
		link: '/produtos',
	},
	{
		id: 5,
		title: 'Coxinha de Carne Seca com Catupiry',
		category: 'Linha Lanche',
		image: require('../../assets/images/coxinhacarnesec.webp'),
		link: '/produtos',
	},
	{
		id: 6,
		title: 'Coxinha de Costela',
		category: 'Linha Lanche',
		image: require('../../assets/images/coxinhacostela.webp'),
		link: '/produtos',
	},
	{
		id: 7,
		title: 'Pastel de Forno de Camarão',
		category: 'Linha Assados',
		image: require('../../assets/images/pastelcamarao.webp'),
		link: '/produtos',
	},
	{
		id: 8,
		title: 'Enroladinho de Queijo com Presunto',
		category: 'Linha Lanche',
		image: require('../../assets/images/enroladoqp.webp'),
		link: '/produtos',
	},
];

const partners = [
	{ name: 'Supermercado Maravista', logo: require('../../assets/images/parceiros/maravista.webp') },
	{ name: 'Rio Sul Supermercados', logo: require('../../assets/images/parceiros/riosul.webp') },
	{ name: 'Mercado Bom Frios', logo: require('../../assets/images/parceiros/bomfrios.webp') },
	{ name: 'Dois Irmãos Padaria e Lanchonete', logo: require('../../assets/images/parceiros/doisirmaos.webp') },
	{ name: 'Santa Marta', logo: require('../../assets/images/parceiros/santamarta.webp') },
	{ name: 'LD Coffee', logo: require('../../assets/images/parceiros/ldcoffee.webp') },
	{ name: 'Mariposa', logo: require('../../assets/images/parceiros/borboleta.webp') },
	{ name: 'Supermercado Armazém Rio', logo: require('../../assets/images/parceiros/armazemrio.webp') },
	{ name: 'Tutto Luce', logo: require('../../assets/images/parceiros/tuttoluce.webp') },
	{ name: "Boni's Gourmet Copacabana", logo: require('../../assets/images/parceiros/bonis.webp') },
	{ name: 'Super Vidal', logo: require('../../assets/images/parceiros/supervidal.webp') },
	{ name: 'Padaria Lady Day Itaipuaçu', logo: require('../../assets/images/parceiros/ladyday.webp') },
	{ name: 'Buffet JM', logo: require('../../assets/images/parceiros/buffetjm.webp') },
	{ name: 'Padaria e Restaurante Real Comary', logo: require('../../assets/images/parceiros/realcomary.webp') },
	{ name: 'Confeitaria Piedade', logo: require('../../assets/images/parceiros/piedade.webp') },
];

const Page =  (props) => {
    const api = useApi();
    const locationInfo = {
        title: 'Onde Estamos Localizados',
        address: 'Rua Waldemar Colombo Garcia - 491 - Magé/RJ - Condomínio Unidas',
        mapUrl: 'https://www.google.com/maps?q=Rua%20Waldemar%20Colombo%20Garcia%20491%20Mag%C3%A9%20RJ%20Condom%C3%ADnio%20Unidas&z=16&output=embed'
    };
    const factoryContacts = [
        {
            icon: require('../../assets/images/whatsApp.png'),
            label: 'WhatsApp',
            value: '(21) 98485-6295',
			href: WHATSAPP_URL,
            external: true
        },
        {
            icon: require('../../assets/images/instagram.png'),
            label: 'Instagram',
            value: '@salato_alimentos',
			href: 'https://www.instagram.com/salato_alimentos/',
			external: true

        },
        {
            icon: require('../../assets/images/facebook.png'),
            label: 'Facebook',
            value: 'facebook/salatoalimentos',
			href: 'https://www.facebook.com/salatoalimentos',
            external: true
        },
        {
            icon: require('../../assets/images/email.png'),
            label: 'E-mail',
            value: 'comercial@salato.com.br',
            whiteIcon: true,
            href: 'mailto:comercial@salato.com.br'
        }
    ];
    const highlightCards = [
        {
            number: '17 anos',
            label: 'de tradição',
            detail: 'Excelência em cada receita',
            icon: require('../../assets/images/guarantee.png')
        },
        {
            number: '+500',
            label: 'clientes atendidos',
            detail: 'Parcerias que se fortalecem',
            icon: require('../../assets/images/Person.png')
        },
        {
            number: 'Entregamos',
            label: 'em todo o RJ',
            detail: 'Agilidade e compromisso',
            icon: require('../../assets/images/Delivery.png')
        },
        {
            number: 'Produtos',
            label: 'congelados',
            detail: 'Mais praticidade e qualidade',
            icon: require('../../assets/images/Cold.png')
        }
    ];


	useEffect(() => {
		const getQtCartCompra = async () => {
			let jwt = Cookies.get('token');
			const json = await api.getCountCar(jwt);
			props.setQt(json.QtCartCompra);

		}

		const getDadosCliente = async () => {
			const json = await api.getClienteDelivery(
				Cookies.get('token'),
				Cookies.get('hash')
			)
			if (json.error === "") {
				props.setDadosCliente(json.Cliente);
			}
		}

		if (isLogged()) {
			getQtCartCompra();
			getDadosCliente();
		}

	}, []);

	return (
		<>
			<SearchArea>
				<div className="hero">
					<FloatingShapes items={[
						{ shape: 'coxinha', color: '#ec1c24', size: 44, bottom: '12%', left: '1.5%', rotate: -18, opacity: .9, hideMobile: true },
						{ shape: 'bolinha', color: '#ffd60a', size: 26, top: '16%', left: '38%', delay: 1.2, hideMobile: true },
						{ shape: 'brilho', color: '#ffd60a', size: 34, top: '14%', right: '6%', delay: .6, hideMobile: true },
						{ shape: 'pastel', color: '#ec1c24', size: 58, bottom: '22%', right: '3%', rotate: 12, opacity: .85, delay: 2, hideMobile: true },
						{ shape: 'bolinha', color: '#ec1c24', size: 14, bottom: '16%', left: '44%', opacity: .7, delay: .3, hideMobile: true },
						{ shape: 'brilho', color: '#ec1c24', size: 22, bottom: '30%', left: '42%', opacity: .6, delay: 1.6, hideMobile: true },
					]} />
					<div className="heroInner">
						<div className="heroText">
							<span className="heroTag">Salato Alimentos</span>
							<h1>
								Os salgados que fazem sucesso <em>há mais de 17 anos.</em>
							</h1>
							<p>
								Produzimos salgados congelados com qualidade, sabor e tradição para mercados,
								padarias, lanchonetes, buffets e distribuidores em todo o Rio de Janeiro.
							</p>
							<div className="heroActions">
								<Link to="/produtos" className="heroButton primary">Conheça nossos produtos</Link>
								<Link to="/contato" className="heroButton secondary">Solicitar orçamento</Link>
							</div>
						</div>
						<div className="heroMedia">
							<div className="heroBlob" aria-hidden="true"></div>
							<SmoothImage
								eager
								src={require('../../assets/images/coxinhasemfundo.webp')}
								alt="Coxinhas Salato"
								width="1100"
								height="1100"
							/>
						</div>
					</div>
				</div>

				<div className="heroHighlights">
					{highlightCards.map((item, i) => (
						<Reveal className="highlightCard" key={item.number} delay={i * 90}>
							<div className="highlightIcon">
								<img src={item.icon} alt="" width="22" height="22" />
							</div>
							<div>
								<strong>{item.number}</strong>
								<span>{item.label}</span>
								<small>{item.detail}</small>
							</div>
						</Reveal>
					))}
				</div>
			</SearchArea>

			<PageArea id="produtos">
				<FloatingShapes items={[
					{ shape: 'coxinha', color: '#ec1c24', size: 38, top: 60, right: '2%', rotate: 20, opacity: .18 },
					{ shape: 'bolinha', color: '#ffd60a', size: 30, top: 140, left: '-1%', opacity: .7, delay: 1, hideMobile: true },
					{ shape: 'brilho', color: '#ec1c24', size: 28, bottom: 80, left: '3%', opacity: .25, delay: 2 },
					{ shape: 'pastel', color: '#ffd60a', size: 52, bottom: 40, right: '1%', rotate: -10, opacity: .8, delay: .5, hideMobile: true },
				]} />
				<Reveal className="productsIntro">
					<div>
						<span className="sectionTag">Nossos produtos</span>
						<h2>Conheça alguns dos nossos produtos</h2>
						<p>Uma linha completa de salgados congelados para o seu negócio vender mais e melhor.</p>
					</div>
					<Link to="/produtos" className="productsButton">
						Ver todos os produtos <span aria-hidden="true">→</span>
					</Link>
				</Reveal>
				<div className="productsGrid">
					{mockProducts.map((item, i) => (
						<Reveal key={item.id} delay={(i % 4) * 80}>
							<Link to={item.link || '/produtos'} className="productCard">
								<div className="productImage">
									<SmoothImage src={item.image} alt={item.title} width="640" height="480" />
									<span className="productTag">{item.category}</span>
								</div>
								<div className="productInfo">
									<strong>{item.title}</strong>
									<span className="productMore">Ver produtos <span aria-hidden="true">→</span></span>
								</div>
							</Link>
						</Reveal>
					))}
				</div>
			</PageArea>

			<ContactArea>
				<Reveal className="ctaBand">
					<div>
						<h2>Quer ter a Salato no seu negócio?</h2>
						<p>Fale com o nosso time comercial e receba uma proposta sob medida.</p>
					</div>
					<div className="ctaActions">
						<a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="ctaWhats">
							<img src={require('../../assets/images/whatsApp.png')} alt="" width="22" height="22" />
							Chamar no WhatsApp
						</a>
						<Link to="/contato" className="ctaGhost">Enviar mensagem</Link>
					</div>
				</Reveal>

				<section className="partnersSection" aria-labelledby="parceiros-titulo">
					<Reveal className="partnersHeading">
						<span className="sectionTag">Quem confia na Salato</span>
						<h2 id="parceiros-titulo">Nossos parceiros</h2>
						<p>Mercados, padarias e cafeterias que servem os nossos salgados todos os dias.</p>
					</Reveal>

					<Reveal className="partnersMarquee">
						<div className="partnersTrack">
							{[...partners, ...partners].map((p, i) => (
								<div className="partnerCard" key={`${p.name}-${i}`} aria-hidden={i >= partners.length}>
									<img src={p.logo} alt={i < partners.length ? p.name : ''} width="360" height="360" loading="lazy" decoding="async" />
								</div>
							))}
						</div>
					</Reveal>
				</section>

				<div className="contactBlock">
					<Reveal className="contactHeading">
						<span className="sectionTag">Fale conosco</span>
						<h2>Estamos aqui para ouvir você</h2>
						<p>Entre em contato para dúvidas, sugestões e atendimento comercial.</p>
					</Reveal>

					<div className="contactVisual">
						<Reveal className="contactImageWrap">
							<SmoothImage src={require('../../assets/images/coxinhabanner.webp')} alt="Salgados Salato" width="1200" height="644" />
						</Reveal>

						<Reveal className="contactCard" delay={120}>
							<strong className="contactCardTitle">Entre em contato</strong>
							{factoryContacts.map((item) => (
								<a className="contactItem" key={item.label} href={item.href} {...(item.external ? { target: '_blank', rel: 'noreferrer' } : {})}>
									<div className="contactIcon">
										<img src={item.icon} alt="" className={item.whiteIcon ? 'whiteIcon' : ''} width="24" height="24" />
									</div>
									<div className="contactText">
										<strong>{item.label}</strong>
										<span>{item.value}</span>
									</div>
									<span className="contactArrow" aria-hidden="true">→</span>
								</a>
							))}
						</Reveal>
					</div>
				</div>

				<section className="clientsMapSection" aria-labelledby="mapa-clientes-titulo">
					<Reveal className="locationHeading">
						<span className="sectionTag">Onde encontrar</span>
						<h2 id="mapa-clientes-titulo">A Salato perto de você</h2>
						<p className="sectionLead">Alguns de nossos clientes como mercados, padarias, cafeterias e restaurantes do Rio de Janeiro que servem os nossos salgados.</p>
					</Reveal>
					<Reveal>
						<ClientsMap />
					</Reveal>
				</section>

				<div className="locationSection">
					<Reveal className="locationHeading">
						<span className="sectionTag">Visite a fábrica</span>
						<h2>{locationInfo.title}</h2>
					</Reveal>

					<Reveal className="locationCard">
						<div className="locationInfo">
							<strong>Fábrica Salato Alimentos</strong>
							<p>{locationInfo.address}</p>
							<a
								className="locationLink"
								href="https://www.google.com/maps/dir/?api=1&destination=Rua%20Waldemar%20Colombo%20Garcia%20491%20Mag%C3%A9%20RJ"
								target="_blank"
								rel="noreferrer"
							>
								Como chegar <span aria-hidden="true">→</span>
							</a>
						</div>

						<div className="locationMapWrap">
							<iframe
								title="Mapa da Salato em Magé"
								src={locationInfo.mapUrl}
								loading="lazy"
								allowFullScreen
								referrerPolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</Reveal>
				</div>
			</ContactArea>
		</>
	)

}



const mapStateToProps = (state) => {
	return {
		nome: state.user.nome,
		qt: state.user.qt,
		StCart: state.user.StCart
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		setNome: (nome) => dispatch({ type: 'SET_NOME', payload: { nome } }),
		setQt: (qt) => dispatch({ type: 'SET_QT', payload: { qt } }),
		setStCart: (StCart) => dispatch({ type: 'SET_CART', payload: { StCart } }),
		setDadosCliente: (DadosCliente) => dispatch({ type: 'SET_DADOSCLIENTE', payload: { DadosCliente } })

	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);